import React from 'react';

import CartItemAgentStockMessage from './CartItemAgentStockMessage';
import AgentDiscountIndicatorList from "./AgentDiscountIndicatorList";

export default function CartItemAgentItemToolbar({item, currentAgent, forecast}) {

  // sanity check
  if (!currentAgent) return null;

  return <div className="relative border">
    <div className="absolute top-0 -left-8 text-2xl">
      <span className="fa fa-user-secret"/>
    </div>

    <div className="bg-agent-purple text-white py-1 px-2 text-sm clearfix">
      <div className="grid grid-cols-2" style={{gridTemplateColumns: '7fr 5fr'}}>
        <AgentDiscountIndicatorList item={item}/>
        {forecast && <CartItemAgentStockMessage forecast={forecast}/>}
      </div>
    </div>
  </div>
}


